<div class="row">
  <div class="col-md-12" *ngIf="loading; else userInfo">
    <h4>{{ "common.waiting" | translate }}</h4>
  </div>
  <ng-template #userInfo>

    <!-- Seller Profile Incomplete Notice -->
    <div class="col-md-12" *ngIf="isSellerProfileIncomplete">
      <div class="alert alert-warning mb-4 border-warning">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <i class="bi bi-exclamation-triangle-fill me-2 fs-4"></i>
            <strong>{{ 'seller_profile.complete_your_profile' | translate }}</strong>
          </div>
          <a [routerLink]="['/seller-setup/type-choice']" class="btn btn-warning btn-sm fw-bold">
            {{ 'seller_profile.setup_now' | translate }}
          </a>
        </div>
      </div>
    </div>

    <!-- Carrier Profile Incomplete Notice -->
    <div class="col-md-12" *ngIf="isCarrierProfileIncomplete">
      <div class="alert alert-warning mb-4 border-warning">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <i class="bi bi-exclamation-triangle-fill me-2 fs-4"></i>
            <strong>{{ 'carrier_profile.complete_your_profile' | translate }}</strong>
          </div>
          <a [routerLink]="['/carrier-setup']" class="btn btn-warning btn-sm fw-bold">
            {{ 'carrier_profile.setup_now' | translate }}
          </a>
        </div>
      </div>
    </div>

    <!-- Start Selling Banner for Users/Buyers -->
    <div class="col-md-12" *ngIf="canBecomeSeller">
      <div class="alert alert-success mb-4 border-success">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <i class="bi bi-shop me-2 fs-4"></i>
            <div>
              <strong>{{ 'seller_profile.start_selling' | translate }}</strong>
              <p class="mb-0 small">{{ 'seller_profile.start_selling_message' | translate }}</p>
            </div>
          </div>
          <a [routerLink]="['/seller-setup/type-choice']" class="btn btn-success fw-bold">
            {{ 'seller_profile.start_selling' | translate }}
          </a>
        </div>
      </div>
    </div>

    <!-- Become Carrier Banner for Users/Buyers -->
    <div class="col-md-12" *ngIf="canBecomeCarrier">
      <div class="alert alert-info mb-4 border-info">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <i class="bi bi-truck me-2 fs-4"></i>
            <div>
              <strong>{{ 'carrier_profile.become_carrier' | translate }}</strong>
              <p class="mb-0 small">{{ 'carrier_profile.become_carrier_message' | translate }}</p>
            </div>
          </div>
          <a [routerLink]="['/carrier-setup']" class="btn btn-info fw-bold">
            {{ 'carrier_profile.setup_now' | translate }}
          </a>
        </div>
      </div>
    </div>

    <!-- Missing Payment Info Notice -->
    <div class="col-md-12" *ngIf="isPaymentInfoMissing && (isPrivateSeller || isCompanySeller)">
      <div class="alert alert-warning mb-4">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ 'seller_profile.missing_payment_info' | translate }}
      </div>
    </div>

    <!-- Phone Verification Required Notice -->
    <div class="col-md-12" *ngIf="isPhoneVerificationRequired && (isPrivateSeller || isCompanySeller)">
      <div class="alert alert-warning mb-4">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ 'seller_profile.verify_phone_to_submit' | translate }}
      </div>
    </div>

    <!-- Missing Registration Document Notice -->
    <div class="col-md-12" *ngIf="isRegistrationDocMissing && isCompanySeller">
      <div class="alert alert-warning mb-4">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ 'seller_profile.missing_registration_doc' | translate }}
      </div>
    </div>

    <!-- Missing Identity Document Notice (Company Seller) -->
    <div class="col-md-12" *ngIf="isIdentityDocMissing && isCompanySeller">
      <div class="alert alert-warning mb-4">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ 'seller_profile.missing_identity_doc' | translate }}
      </div>
    </div>

    <!-- Missing Identity Document Notice (Private Seller) -->
    <div class="col-md-12" *ngIf="isPrivateSellerIdentityDocMissing && isPrivateSeller">
      <div class="alert alert-warning mb-4">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ 'seller_profile.missing_identity_doc' | translate }}
      </div>
    </div>

    <!-- Account Rejected Notice -->
    <div class="col-md-12" *ngIf="isRejected && (isPrivateSeller || isCompanySeller)">
      <div class="alert alert-danger mb-4">
        <div class="d-flex align-items-start">
          <i class="bi bi-x-circle-fill me-2 fs-4"></i>
          <div class="flex-grow-1">
            <h5 class="alert-heading mb-2">{{ 'seller_profile.account_rejected_title' | translate }}</h5>
            <p class="mb-2">{{ 'seller_profile.account_rejected_message' | translate }}</p>
            <hr class="my-2">
            <p class="mb-0"><strong>{{ 'seller_profile.rejection_reason' | translate }}:</strong> {{ rejectionReason }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Submit for Approval Button (First Time) -->
    <div class="col-md-12" *ngIf="canSubmitForApproval && !isRejected && (isPrivateSeller || isCompanySeller)">
      <div class="alert alert-info mb-4 d-flex justify-content-between align-items-center">
        <div>
          <i class="bi bi-info-circle-fill me-2"></i>
          {{ 'seller_profile.complete_profile_notice' | translate }}
        </div>
        <button type="button" class="btn btn-primary" (click)="submitForApproval()">
          {{ 'seller_profile.submit_for_approval' | translate }}
        </button>
      </div>
    </div>

    <!-- Resubmit for Approval Button (After Rejection) -->
    <div class="col-md-12" *ngIf="canSubmitForApproval && isRejected && (isPrivateSeller || isCompanySeller)">
      <div class="alert alert-warning mb-4 d-flex justify-content-between align-items-center">
        <div>
          <i class="bi bi-arrow-clockwise me-2"></i>
          {{ 'seller_profile.resubmit_notice' | translate }}
        </div>
        <button type="button" class="btn btn-warning" (click)="submitForApproval()">
          {{ 'seller_profile.resubmit_for_approval' | translate }}
        </button>
      </div>
    </div>

    <!-- Pending Approval Notice -->
    <div class="col-md-12" *ngIf="isPending">
      <div class="alert alert-warning mb-4">
        <i class="bi bi-info-circle-fill me-2"></i>
        {{ 'seller_profile.pending_approval_notice' | translate }}
      </div>
    </div>

    <!-- Private Seller Layout -->
    <ng-container *ngIf="isPrivateSeller">

      <app-payment-edit-modal
        [isOpen]="showPaymentModal"
        [existingPaymentInfo]="existingPaymentInfo"
        (close)="closePaymentModal()"
        (save)="onSavePayment($event)">
      </app-payment-edit-modal>

      <app-verification-modal
        [isOpen]="showVerificationModal"
        [phoneNumber]="sellerDetailsFromEndpoint?.paymentInfo?.mobileMoneyNumber"
        [resendDisabled]="resendDisabled"
        [resendCountdown]="resendCountdown"
        [errorMessage]="verificationError"
        (close)="closeVerificationModal()"
        (submit)="onVerifyCode($event)"
        (resend)="onResendCode()">
      </app-verification-modal>

      <!-- Document Upload Modal -->
      <app-document-upload-modal
        [isOpen]="showUploadModal"
        [documentType]="uploadDocumentType"
        [sellerType]="'private'"
        [sellerId]="sellerId"
        [autoReload]="true"
        (close)="closeUploadModal()"
        (uploadComplete)="onDocumentUploaded($event)">
      </app-document-upload-modal>

      <!-- Confirmation Modal -->
      <ng-container *ngIf="showConfirmModal">
        <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{confirmModalTitle}}</h5>
                <button type="button" class="btn-close" (click)="closeConfirmModal()"></button>
              </div>
              <div class="modal-body">
                {{confirmModalMessage}}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeConfirmModal()">
                  {{'common.cancel' | translate}}
                </button>
                <button type="button" class="btn btn-danger" (click)="onConfirmAction()">
                  {{'common.delete' | translate}} 
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
      </ng-container>

      <!-- Card 1: Personal Info - Full Width -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5>{{'seller_profile.personal_info' | translate}}</h5>
          </div>
          <div class="card-body">
            <p><span class="badge bg-success mb-2">{{'seller_profile.seller_type_private' | translate}}</span></p>
            <p><label>{{'seller_profile.first_name' | translate}} : </label> {{sellerDetailsFromEndpoint.firstName }}</p>
            <p><label>{{'seller_profile.last_name' | translate}} : </label> {{sellerDetailsFromEndpoint.lastName }}</p>
            <p><label>{{'dashboard.email_address' | translate}} :</label> {{user?.email }}</p>
            <p><label>{{'login.phone_number' | translate}} :</label> {{user?.phone }}</p>
            <p><label>{{'common.country' | translate}}: </label> {{ user?.country?.name || '-' }}</p>
            <p><a class="btn btn-primary" [routerLink]="['/user/' + (user?.id ?? '') + '/edit']">{{'common.edit' | translate}}</a></p>
          </div>
        </div>
      </div>

      <!-- Card 2: Payment Information - Full Width -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{'seller_profile.payment_info' | translate}}</h5>
            <button type="button" class="btn btn-sm btn-outline-primary" *ngIf="canEditSellerInfo" (click)="openEditPaymentModal()">{{'common.edit' | translate}}</button>
          </div>
          <div class="card-body">
            <ng-container *ngIf="sellerDetailsFromEndpoint?.paymentInfo?.paymentType === 'MOBILE_MONEY'">
              <p><label>{{'seller_profile.payment_type' | translate}} :</label> {{'seller_profile.mobile_money' | translate}}</p>
              <p><label>{{'seller_profile.provider' | translate}} :</label> {{getMobileProviderLabel() | translate}}</p>
              <p class="d-flex align-items-center">
                <label class="mb-0">{{'seller_profile.mobile_number' | translate}} :</label>
                <span class="ms-2">{{sellerDetailsFromEndpoint?.paymentInfo?.mobileMoneyNumber}}</span>
                <button type="button" *ngIf="needsPhoneVerification" class="btn btn-sm btn-warning ms-2" (click)="openVerificationModal()">
                  {{'seller_profile.verify' | translate}}
                </button>
                <span *ngIf="!needsPhoneVerification && sellerDetailsFromEndpoint?.paymentInfo?.numberVerified" class="badge bg-success ms-2">
                  <i class="fas fa-check me-1"></i>{{'seller_profile.verified' | translate}}
                </span>
              </p>
            </ng-container>

            <ng-container *ngIf="sellerDetailsFromEndpoint?.paymentInfo?.paymentType === 'BANK'">
              <p><label>{{'seller_profile.payment_type' | translate}} :</label> {{'seller_profile.bank_transfer' | translate}}</p>
              <p><label>{{'seller_profile.bank_name' | translate}} :</label> {{sellerDetailsFromEndpoint?.paymentInfo?.bankName}}</p>
              <p><label>{{'seller_profile.account_number' | translate}} :</label> {{sellerDetailsFromEndpoint?.paymentInfo?.accountNumber}}</p>
              <p><label>{{'seller_profile.account_holder' | translate}} :</label> {{sellerDetailsFromEndpoint?.paymentInfo?.accountHolderName}}</p>
            </ng-container>

            <ng-container *ngIf="!sellerDetailsFromEndpoint?.paymentInfo">
              <p class="text-muted">{{'seller_profile.no_payment_info' | translate}}</p>
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="openAddPaymentModal()">{{'seller_profile.add_payment' | translate}}</button>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Card 3: Identity Document - Full Width -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5>{{'seller_profile.identity_document' | translate}}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-auto">
                <p class="mb-1"><label>{{'seller_profile.identity_document' | translate}}</label></p>
                <!-- Show download/delete buttons when document exists -->
                <ng-container *ngIf="isPrivateSellerDocumentUploaded('IdCard') || isPrivateSellerDocumentUploaded('Passport')">
                  <div class="d-flex gap-2">
                    <button type="button" class="btn btn-outline-primary" (click)="downloadSellerDocumentById(getPrivateSellerDocumentByType('IdCard')?.id || getPrivateSellerDocumentByType('Passport')?.id)">
                      <i class="bi bi-download me-1"></i>{{'seller_profile.download_document' | translate}}
                    </button>
                    <button type="button" class="btn btn-outline-danger" *ngIf="canDeleteDocuments" (click)="deleteSellerDocumentById(getPrivateSellerDocumentByType('IdCard')?.id || getPrivateSellerDocumentByType('Passport')?.id, 'identity')">
                      <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                    </button>
                  </div>
                </ng-container>
                <!-- Show upload button when document is missing -->
                <div *ngIf="!isPrivateSellerDocumentUploaded('IdCard') && !isPrivateSellerDocumentUploaded('Passport')">
                        <button type="button" class="btn btn-success" *ngIf="canEditSellerInfo" (click)="openUploadModal('identity')">
                    <i class="bi bi-upload me-1"></i>{{'seller_profile.upload_document' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 4: Shipping Address - Full Width -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header" id="shipping-box">
            <h5>{{'dashboard.default_shipping_address' | translate}}</h5>
          </div>
          <div class="card-body">
            <div *ngIf="defaultShippingAddress">
              <p><label>{{'common.name' | translate}} :</label> {{ defaultShippingAddress.name }}</p>
              <p><label>{{'user_profile.region' | translate}} :</label> {{ defaultShippingAddress.region }}</p>
              <p><label>{{'common.city' | translate}} :</label> {{ defaultShippingAddress.town }}</p>
              <p><label>{{'user_profile.address_1' | translate}} :</label> {{ defaultShippingAddress.addressLine1 }}</p>
              <p><label>{{'user_profile.address_2' | translate}} :</label> {{ defaultShippingAddress.addressLine2 }}</p>
            </div>
            <p><a class="btn btn-primary" [routerLink]="['/user/shipping-addresses']">{{'sidebar.my_addresses' | translate}}</a></p>
          </div>
        </div>
      </div>

      <!-- Delete Account Section -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-body text-center">
            <button type="button" class="btn btn-outline-danger" (click)="openDeleteAccountModal()">
              <i class="bi bi-trash me-2"></i>{{'profile.delete_account' | translate}}
            </button>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- Company Seller Layout -->
    <ng-container *ngIf="isCompanySeller">

      <app-payment-edit-modal
        [isOpen]="showPaymentModal"
        [existingPaymentInfo]="existingPaymentInfo"
        (close)="closePaymentModal()"
        (save)="onSavePayment($event)">
      </app-payment-edit-modal>

      <app-company-info-edit-modal
        [isOpen]="showCompanyInfoModal"
        [existingCompanyInfo]="existingCompanyInfo"
        (close)="closeCompanyInfoModal()"
        (save)="onSaveCompanyInfo($event)">
      </app-company-info-edit-modal>

      <app-verification-modal
        [isOpen]="showVerificationModal"
        [phoneNumber]="sellerDetailsFromEndpoint?.paymentInfo?.mobileMoneyNumber"
        [resendDisabled]="resendDisabled"
        [resendCountdown]="resendCountdown"
        [errorMessage]="verificationError"
        (close)="closeVerificationModal()"
        (submit)="onVerifyCode($event)"
        (resend)="onResendCode()">
      </app-verification-modal>

      <!-- Document Upload Modal -->
      <app-document-upload-modal
        [isOpen]="showUploadModal"
        [documentType]="uploadDocumentType"
        [sellerType]="isPrivateSeller ? 'private' : 'company'"
        [sellerId]="sellerId"
        [autoReload]="true"
        (close)="closeUploadModal()"
        (uploadComplete)="onDocumentUploaded($event)">
      </app-document-upload-modal>

      <!-- Confirmation Modal -->
      <ng-container *ngIf="showConfirmModal">
        <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{confirmModalTitle}}</h5>
                <button type="button" class="btn-close" (click)="closeConfirmModal()"></button>
              </div>
              <div class="modal-body">
                {{confirmModalMessage}}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeConfirmModal()">
                  {{'common.cancel' | translate}}
                </button>
                <button type="button" class="btn btn-danger" (click)="onConfirmAction()">
                  {{'common.delete' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
      </ng-container>

      <!-- Card 1: Personal Info - Full Width -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5>{{'seller_profile.personal_info' | translate}}</h5>
          </div>
          <div class="card-body">
            <p><span class="badge bg-success mb-2">{{'seller_profile.seller_type_company' | translate}}</span></p>
            <p><label>{{'seller_profile.company_name' | translate}} : </label> {{sellerDetailsFromEndpoint.companyName }}</p>
            <p><label>{{'dashboard.email_address' | translate}} :</label> {{user?.email }}</p>
            <p><label>{{'login.phone_number' | translate}} :</label> {{user?.phone }}</p>
            <p><label>{{'common.country' | translate}}: </label> {{ user?.country?.name || '-' }}</p>
            <p><a class="btn btn-primary" [routerLink]="['/user/' + (user?.id ?? '') + '/edit']">{{'common.edit' | translate}}</a></p>
          </div>
        </div>
      </div>

      <!-- Card 2: Company Details - Full Width -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{'seller_profile.company_details' | translate}}</h5>
            <button type="button" class="btn btn-sm btn-outline-primary" *ngIf="canEditSellerInfo" (click)="openEditCompanyInfoModal()">
              {{'common.edit' | translate}}
            </button>
          </div>
          <div class="card-body">
            <div class="row">
              <!-- Left column: Legal Info + Legal Representative -->
              <div class="col-md-6">
                <div class="mb-3">
                  <h6 class="text-primary">{{'seller_setup.company_legal_info' | translate}}</h6>
                  <p *ngIf="sellerDetailsFromEndpoint.legalInfo?.rccm">
                    <label>{{'seller_profile.rccm' | translate}} :</label> {{sellerDetailsFromEndpoint.legalInfo.rccm}}
                  </p>
                  <p *ngIf="!sellerDetailsFromEndpoint.legalInfo?.rccm" class="text-muted">
                    <label>{{'seller_profile.rccm' | translate}} :</label> {{'seller_profile.not_provided' | translate}}
                  </p>
                  <p *ngIf="sellerDetailsFromEndpoint.legalInfo?.niu">
                    <label>{{'seller_profile.niu' | translate}} :</label> {{sellerDetailsFromEndpoint.legalInfo.niu}}
                  </p>
                  <p *ngIf="!sellerDetailsFromEndpoint.legalInfo?.niu" class="text-muted">
                    <label>{{'seller_profile.niu' | translate}} :</label> {{'seller_profile.not_provided' | translate}}
                  </p>
                  <p *ngIf="sellerDetailsFromEndpoint.legalInfo?.businessLicenseNumber">
                    <label>{{'seller_profile.business_license' | translate}} :</label> {{sellerDetailsFromEndpoint.legalInfo.businessLicenseNumber}}
                  </p>
                  <p *ngIf="!sellerDetailsFromEndpoint.legalInfo?.businessLicenseNumber" class="text-muted">
                    <label>{{'seller_profile.business_license' | translate}} :</label> {{'seller_profile.not_provided' | translate}}
                  </p>
                </div>

                <div class="mb-3">
                  <h6 class="text-primary">{{'seller_profile.legal_representative' | translate}}</h6>
                  <p *ngIf="sellerDetailsFromEndpoint.legalRepresentative?.fullName">
                    <label>{{'seller_profile.full_name' | translate}} :</label> {{sellerDetailsFromEndpoint.legalRepresentative.fullName}}
                  </p>
                  <p *ngIf="!sellerDetailsFromEndpoint.legalRepresentative?.fullName" class="text-muted">
                    <label>{{'seller_profile.full_name' | translate}} :</label> {{'seller_profile.not_provided' | translate}}
                  </p>
                  <p *ngIf="sellerDetailsFromEndpoint.legalRepresentative?.position">
                    <label>{{'seller_profile.position' | translate}} :</label> {{sellerDetailsFromEndpoint.legalRepresentative.position}}
                  </p>
                  <p *ngIf="!sellerDetailsFromEndpoint.legalRepresentative?.position" class="text-muted">
                    <label>{{'seller_profile.position' | translate}} :</label> {{'seller_profile.not_provided' | translate}}
                  </p>
                  <p *ngIf="sellerDetailsFromEndpoint.legalRepresentative?.phoneNumber">
                    <label>{{'common.phone' | translate}} :</label> {{sellerDetailsFromEndpoint.legalRepresentative.phoneNumber}}
                  </p>
                  <p *ngIf="!sellerDetailsFromEndpoint.legalRepresentative?.phoneNumber" class="text-muted">
                    <label>{{'common.phone' | translate}} :</label> {{'seller_profile.not_provided' | translate}}
                  </p>
                </div>

                <div class="mb-3">
                  <h6 class="text-primary">{{'seller_profile.documents' | translate}}</h6>
                  
                  <!-- Identity Document (IdCard or Passport) -->
                  <div class="mb-4 pb-3 border-bottom">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="mb-0">{{'seller_profile.identity_document' | translate}}</h6>
                      <span *ngIf="isCompanySellerDocumentUploaded('IdCard') || isCompanySellerDocumentUploaded('Passport')" class="badge bg-success">
                        {{'carrier_profile.uploaded' | translate}}
                      </span>
                      <span *ngIf="!isCompanySellerDocumentUploaded('IdCard') && !isCompanySellerDocumentUploaded('Passport')" class="badge bg-warning">
                        {{'common.missing' | translate}}
                      </span>
                    </div>
                    <ng-container *ngIf="isCompanySellerDocumentUploaded('IdCard') || isCompanySellerDocumentUploaded('Passport')">
                      <div class="d-flex gap-2">
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadSellerDocumentById(getCompanySellerDocumentByType('IdCard')?.id || getCompanySellerDocumentByType('Passport')?.id)">
                          <i class="bi bi-download me-1"></i>{{'seller_profile.download_document' | translate}}
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="canDeleteDocuments" (click)="deleteSellerDocumentById(getCompanySellerDocumentByType('IdCard')?.id || getCompanySellerDocumentByType('Passport')?.id, 'identity')">
                          <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                        </button>
                      </div>
                    </ng-container>
                    <button *ngIf="!isCompanySellerDocumentUploaded('IdCard') && !isCompanySellerDocumentUploaded('Passport') && canEditSellerInfo" 
                            type="button" class="btn btn-success" (click)="openUploadModal('identity')">
                      <i class="bi bi-upload me-1"></i>{{'seller_profile.upload_document' | translate}}
                    </button>
                  </div>

                  <!-- Registration Certificate -->
                  <div class="mb-4 pb-3 border-bottom">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="mb-0">{{'seller_setup.registration_certificate' | translate}}</h6>
                      <span *ngIf="isCompanySellerDocumentUploaded('RegistrationCertificate')" class="badge bg-success">
                        {{'carrier_profile.uploaded' | translate}}
                      </span>
                      <span *ngIf="!isCompanySellerDocumentUploaded('RegistrationCertificate')" class="badge bg-warning">
                        {{'common.missing' | translate}}
                      </span>
                    </div>
                    <ng-container *ngIf="isCompanySellerDocumentUploaded('RegistrationCertificate')">
                      <div class="d-flex gap-2">
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadSellerDocumentById(getCompanySellerDocumentByType('RegistrationCertificate')?.id)">
                          <i class="bi bi-download me-1"></i>{{'seller_profile.download_document' | translate}}
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="canDeleteDocuments" (click)="deleteSellerDocumentById(getCompanySellerDocumentByType('RegistrationCertificate')?.id, 'registration')">
                          <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                        </button>
                      </div>
                    </ng-container>
                    <button *ngIf="!isCompanySellerDocumentUploaded('RegistrationCertificate') && canEditSellerInfo" 
                            type="button" class="btn btn-success" (click)="openUploadModal('registration')">
                      <i class="bi bi-upload me-1"></i>{{'seller_profile.upload_document' | translate}}
                    </button>
                  </div>

                  <!-- Tax Compliance Certificate -->
                  <div class="mb-4 pb-3 border-bottom">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="mb-0">{{'seller_setup.tax_compliance_certificate' | translate}}</h6>
                      <span *ngIf="isCompanySellerDocumentUploaded('TaxComplianceCertificate')" class="badge bg-success">
                        {{'carrier_profile.uploaded' | translate}}
                      </span>
                      <span *ngIf="!isCompanySellerDocumentUploaded('TaxComplianceCertificate')" class="badge bg-warning">
                        {{'common.missing' | translate}}
                      </span>
                    </div>
                    <p *ngIf="isCompanySellerDocumentUploaded('TaxComplianceCertificate') && getCompanySellerDocumentByType('TaxComplianceCertificate')?.deliveredAt" class="text-muted small">
                      <strong>{{'carrier_setup.delivery_date' | translate}}:</strong> {{getCompanySellerDocumentByType('TaxComplianceCertificate')?.deliveredAt}}
                    </p>
                    <ng-container *ngIf="isCompanySellerDocumentUploaded('TaxComplianceCertificate')">
                      <div class="d-flex gap-2">
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadSellerDocumentById(getCompanySellerDocumentByType('TaxComplianceCertificate')?.id)">
                          <i class="bi bi-download me-1"></i>{{'seller_profile.download_document' | translate}}
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="canDeleteDocuments" (click)="deleteSellerDocumentById(getCompanySellerDocumentByType('TaxComplianceCertificate')?.id, 'tax')">
                          <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                        </button>
                      </div>
                    </ng-container>
                    <button *ngIf="!isCompanySellerDocumentUploaded('TaxComplianceCertificate') && canEditSellerInfo" 
                            type="button" class="btn btn-success" (click)="openUploadModal('tax')">
                      <i class="bi bi-upload me-1"></i>{{'seller_profile.upload_document' | translate}}
                    </button>
                  </div>

                  <!-- Registration of Incorporation -->
                  <div class="mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="mb-0">{{'seller_setup.registration_of_incorporation' | translate}}</h6>
                      <span *ngIf="isCompanySellerDocumentUploaded('RegistrationOfIncorporation')" class="badge bg-success">
                        {{'carrier_profile.uploaded' | translate}}
                      </span>
                      <span *ngIf="!isCompanySellerDocumentUploaded('RegistrationOfIncorporation')" class="badge bg-warning">
                        {{'common.missing' | translate}}
                      </span>
                    </div>
                    <ng-container *ngIf="isCompanySellerDocumentUploaded('RegistrationOfIncorporation')">
                      <div class="d-flex gap-2">
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadSellerDocumentById(getCompanySellerDocumentByType('RegistrationOfIncorporation')?.id)">
                          <i class="bi bi-download me-1"></i>{{'seller_profile.download_document' | translate}}
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="canDeleteDocuments" (click)="deleteSellerDocumentById(getCompanySellerDocumentByType('RegistrationOfIncorporation')?.id, 'incorporation')">
                          <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                        </button>
                      </div>
                    </ng-container>
                    <button *ngIf="!isCompanySellerDocumentUploaded('RegistrationOfIncorporation') && canEditSellerInfo" 
                            type="button" class="btn btn-success" (click)="openUploadModal('incorporation')">
                      <i class="bi bi-upload me-1"></i>{{'seller_profile.upload_document' | translate}}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Right column: Operational Info -->
              <div class="col-md-6">
                <h6 class="text-primary">{{'seller_setup.company_operational' | translate}}</h6>
                <p *ngIf="sellerDetailsFromEndpoint.operationalInfo?.companyEmail">
                  <label>{{'seller_profile.company_email' | translate}} :</label> {{sellerDetailsFromEndpoint.operationalInfo.companyEmail}}
                </p>
                <p *ngIf="sellerDetailsFromEndpoint.operationalInfo?.companyPhoneNumber">
                  <label>{{'seller_profile.company_phone' | translate}} :</label> {{sellerDetailsFromEndpoint.operationalInfo.companyPhoneNumber}}
                </p>
                <p *ngIf="sellerDetailsFromEndpoint.operationalInfo?.country">
                  <label>{{'common.country' | translate}} :</label> {{sellerDetailsFromEndpoint.operationalInfo.country}}
                </p>
                <p *ngIf="sellerDetailsFromEndpoint.operationalInfo?.city">
                  <label>{{'common.city' | translate}} :</label> {{sellerDetailsFromEndpoint.operationalInfo.city}}
                </p>
                <p *ngIf="sellerDetailsFromEndpoint.operationalInfo?.address">
                  <label>{{'seller_profile.address' | translate}} :</label> {{sellerDetailsFromEndpoint.operationalInfo.address}}
                </p>
                <p *ngIf="sellerDetailsFromEndpoint.operationalInfo?.description">
                  <label>{{'seller_profile.description' | translate}} :</label> {{sellerDetailsFromEndpoint.operationalInfo.description}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 3: Payment Information - Full Width -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">{{'seller_profile.payment_info' | translate}}</h5>
          </div>
          <div class="card-body">
            <ng-container *ngIf="sellerDetailsFromEndpoint.paymentInfo?.paymentType === 'MOBILE_MONEY'">
              <p><label>{{'seller_profile.payment_type' | translate}} :</label> {{'seller_profile.mobile_money' | translate}}</p>
              <p><label>{{'seller_profile.provider' | translate}} :</label> {{getMobileProviderLabel() | translate}}</p>
              <p class="d-flex align-items-center">
                <label class="mb-0">{{'seller_profile.mobile_number' | translate}} :</label>
                <span class="ms-2">{{sellerDetailsFromEndpoint.paymentInfo.mobileMoneyNumber}}</span>
                <button type="button" *ngIf="needsPhoneVerification" class="btn btn-sm btn-warning ms-2" (click)="openVerificationModal()">
                  {{'seller_profile.verify' | translate}}
                </button>
                <span *ngIf="!needsPhoneVerification && sellerDetailsFromEndpoint.paymentInfo.numberVerified" class="badge bg-success ms-2">
                  <i class="fas fa-check me-1"></i>{{'seller_profile.verified' | translate}}
                </span>
              </p>
              <button type="button" class="btn btn-sm btn-outline-primary mt-2" *ngIf="canEditSellerInfo" (click)="openEditPaymentModal()">{{'common.edit' | translate}}</button>
            </ng-container>

            <ng-container *ngIf="sellerDetailsFromEndpoint.paymentInfo?.paymentType === 'BANK'">
              <p><label>{{'seller_profile.payment_type' | translate}} :</label> {{'seller_profile.bank_transfer' | translate}}</p>
              <p><label>{{'seller_profile.bank_name' | translate}} :</label> {{sellerDetailsFromEndpoint.paymentInfo.bankName}}</p>
              <p><label>{{'seller_profile.account_number' | translate}} :</label> {{sellerDetailsFromEndpoint.paymentInfo.accountNumber}}</p>
              <p><label>{{'seller_profile.account_holder' | translate}} :</label> {{sellerDetailsFromEndpoint.paymentInfo.accountHolderName}}</p>
              <button type="button" class="btn btn-sm btn-outline-primary mt-2" *ngIf="canEditSellerInfo" (click)="openEditPaymentModal()">{{'common.edit' | translate}}</button>
            </ng-container>

            <ng-container *ngIf="!sellerDetailsFromEndpoint.paymentInfo">
              <p class="text-muted">{{'seller_profile.no_payment_info' | translate}}</p>
              <button type="button" class="btn btn-sm btn-outline-primary" *ngIf="canEditSellerInfo" (click)="openAddPaymentModal()">{{'seller_profile.add_payment' | translate}}</button>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Delete Account Section -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-body text-center">
            <button type="button" class="btn btn-outline-danger" (click)="openDeleteAccountModal()">
              <i class="bi bi-trash me-2"></i>{{'profile.delete_account' | translate}}
            </button>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- Carrier (Delivery Agent) Layout -->
    <ng-container *ngIf="isCarrier && isPrivateCarrier">

      <!-- Confirmation Modal -->
      <ng-container *ngIf="showConfirmModal">
        <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{confirmModalTitle}}</h5>
                <button type="button" class="btn-close" (click)="closeConfirmModal()"></button>
              </div>
              <div class="modal-body">
                {{confirmModalMessage}}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeConfirmModal()">
                  {{'common.cancel' | translate}}
                </button>
                <button type="button" class="btn btn-danger" (click)="onConfirmAction()">
                  {{'common.delete' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
      </ng-container>

      <!-- Submit for Approval Section (PENDING status) -->
      <div class="col-md-12" *ngIf="carrierDetailsFromEndpoint?.status === 'PENDING'">
        <div class="alert alert-info mb-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <i class="bi bi-info-circle-fill me-2"></i>
              <strong>{{ 'carrier_profile.submit_for_approval_title' | translate }}</strong>
            </div>
            <button type="button"
                    class="btn btn-primary"
                    [disabled]="!canCarrierSubmitForApproval"
                    (click)="submitCarrierForApproval()">
              {{ 'carrier_profile.submit_for_approval' | translate }}
            </button>
          </div>

          <!-- Missing Document Notice -->
          <div *ngIf="isCarrierDocumentMissing" class="alert alert-warning mb-2">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ 'carrier_profile.missing_identity_doc' | translate }}
          </div>

          <!-- Phone Verification Required Notice -->
          <div *ngIf="isCarrierPhoneVerificationRequired" class="alert alert-warning mb-2">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ 'carrier_profile.verify_phone_to_submit' | translate }}
          </div>
        </div>
      </div>

      <!-- Resubmit for Approval Section (REJECTED status) -->
      <div class="col-md-12" *ngIf="carrierDetailsFromEndpoint?.status === 'REJECTED'">
        <div class="alert alert-warning mb-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <i class="bi bi-arrow-clockwise me-2"></i>
              {{ 'carrier_profile.resubmit_notice' | translate }}
            </div>
            <button type="button"
                    class="btn btn-warning"
                    [disabled]="!canCarrierSubmitForApproval"
                    (click)="submitCarrierForApproval()">
              {{ 'carrier_profile.resubmit_for_approval' | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Completed/Under Review Status Notice -->
      <div class="col-md-12" *ngIf="carrierDetailsFromEndpoint?.status === 'COMPLETED'">
        <div class="alert alert-warning mb-4">
          <i class="bi bi-info-circle-fill me-2"></i>
          {{ 'carrier_profile.pending_approval_notice' | translate }}
        </div>
      </div>

      <!-- Account Rejected Notice -->
      <div class="col-md-12" *ngIf="isCarrierRejected">
        <div class="alert alert-danger mb-4">
          <div class="d-flex align-items-start">
            <i class="bi bi-x-circle-fill me-2 fs-4"></i>
            <div class="flex-grow-1">
              <h5 class="alert-heading mb-2">{{ 'carrier_profile.account_rejected_title' | translate }}</h5>
              <p class="mb-2">{{ 'carrier_profile.account_rejected_message' | translate }}</p>
              <hr class="my-2">
              <p class="mb-0"><strong>{{ 'carrier_profile.rejection_reason' | translate }}:</strong> {{ carrierRejectionReason }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 1: Personal Info -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5>{{'carrier_profile.personal_info' | translate}}</h5>
          </div>
          <div class="card-body">
            <p><span class="badge bg-success mb-2">{{'carrier_profile.delivery_agent' | translate}}</span></p>
            <p><label>{{'carrier_profile.first_name' | translate}} : </label> {{carrierDetailsFromEndpoint?.firstName }}</p>
            <p><label>{{'carrier_profile.last_name' | translate}} : </label> {{carrierDetailsFromEndpoint?.lastName }}</p>
            <p><label>{{'dashboard.email_address' | translate}} :</label> {{user?.email }}</p>
            <p><label>{{'login.phone_number' | translate}} :</label> {{user?.phone }}</p>
            <p><label>{{'common.country' | translate}}: </label> {{ user?.country?.name || '-' }}</p>
            <p><a class="btn btn-primary" [routerLink]="['/user/' + (user?.id ?? '') + '/edit']">{{'common.edit' | translate}}</a></p>
          </div>
        </div>
      </div>

      <!-- Card 2: Payment Information -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">{{'carrier_profile.payment_info' | translate}}</h5>
          </div>
          <div class="card-body">
            <ng-container *ngIf="carrierDetailsFromEndpoint?.paymentInfo?.paymentType === 'MOBILE_MONEY'">
              <p><label>{{'carrier_profile.payment_type' | translate}} :</label> {{'carrier_profile.mobile_money' | translate}}</p>
              <p><label>{{'carrier_profile.provider' | translate}} :</label> {{carrierDetailsFromEndpoint?.paymentInfo?.mobileMoneyProvider}}</p>
              <p class="d-flex align-items-center">
                <label class="mb-0">{{'carrier_profile.mobile_number' | translate}} :</label>
                <span class="ms-2">{{carrierDetailsFromEndpoint?.paymentInfo?.mobileMoneyNumber}}</span>
                <button type="button" *ngIf="needsCarrierPhoneVerification" class="btn btn-sm btn-warning ms-2" (click)="openCarrierVerificationModal()">
                  {{'carrier_profile.verify' | translate}}
                </button>
                <span *ngIf="!needsCarrierPhoneVerification && carrierDetailsFromEndpoint?.paymentInfo?.numberVerified" class="badge bg-success ms-2">
                  <i class="fas fa-check me-1"></i>{{'carrier_profile.verified' | translate}}
                </span>
              </p>
            </ng-container>

            <ng-container *ngIf="carrierDetailsFromEndpoint?.paymentInfo?.paymentType === 'BANK'">
              <p><label>{{'carrier_profile.payment_type' | translate}} :</label> {{'carrier_profile.bank_transfer' | translate}}</p>
              <p><label>{{'carrier_profile.bank_name' | translate}} :</label> {{carrierDetailsFromEndpoint?.paymentInfo?.bankName}}</p>
              <p><label>{{'carrier_profile.account_number' | translate}} :</label> {{carrierDetailsFromEndpoint?.paymentInfo?.accountNumber}}</p>
              <p><label>{{'carrier_profile.account_holder' | translate}} :</label> {{carrierDetailsFromEndpoint?.paymentInfo?.accountHolderName}}</p>
            </ng-container>

            <ng-container *ngIf="!carrierDetailsFromEndpoint?.paymentInfo">
              <p class="text-muted">{{'carrier_profile.no_payment_info' | translate}}</p>
            </ng-container>
            <button type="button" class="btn btn-sm btn-outline-primary mt-2" *ngIf="canEditCarrierInfo" (click)="openEditCarrierPaymentModal()">{{'common.edit' | translate}}</button>
          </div>
        </div>
      </div>

      <!-- Card 3: Documents -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5>{{'carrier_profile.documents' | translate}}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-auto">
                <p class="mb-1"><label>{{'carrier_profile.identity_document' | translate}}</label></p>
                <!-- Show download/delete buttons when document exists -->
                <div class="d-flex gap-2" *ngIf="carrierDetailsFromEndpoint?.documents && carrierDetailsFromEndpoint.documents.length > 0">
                  <button type="button" class="btn btn-outline-primary" (click)="downloadCarrierDocument(carrierDetailsFromEndpoint?.documents[0]?.id)">
                    <i class="bi bi-download me-1"></i>{{'carrier_profile.download_document' | translate}}
                  </button>
                  <button type="button" class="btn btn-outline-danger" *ngIf="canDeleteCarrierDocuments" (click)="deleteCarrierDocument(carrierDetailsFromEndpoint?.documents[0]?.id)">
                    <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                  </button>
                </div>
                <!-- Show upload button when document is missing -->
                <div *ngIf="!carrierDetailsFromEndpoint?.documents || carrierDetailsFromEndpoint.documents.length === 0">
                  <button type="button" class="btn btn-success" (click)="openCarrierUploadModal()">
                    <i class="bi bi-upload me-1"></i>{{'carrier_profile.upload_document' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Carrier Verification Modal -->
      <app-verification-modal
        [isOpen]="showVerificationModal"
        [phoneNumber]="carrierDetailsFromEndpoint?.paymentInfo?.mobileMoneyNumber"
        [resendDisabled]="resendDisabled"
        [resendCountdown]="resendCountdown"
        [errorMessage]="verificationError"
        (close)="closeVerificationModal()"
        (submit)="onVerifyCarrierCode($event)"
        (resend)="onResendCarrierCode()">
      </app-verification-modal>

      <!-- Carrier Document Upload Modal -->
      <app-document-upload-modal
        [isOpen]="showUploadModal"
        [documentType]="'identity'"
        [sellerType]="'private'"
        [resourceType]="'LogisticAgent'"
        [sellerId]="carrierDetailsFromEndpoint?.id"
        [autoReload]="true"
        (close)="closeUploadModal()"
        (uploadComplete)="onCarrierDocumentUploaded($event)">
      </app-document-upload-modal>

      <!-- Carrier Payment Edit Modal -->
      <app-payment-edit-modal
        [isOpen]="showPaymentModal"
        [existingPaymentInfo]="existingPaymentInfo"
        (close)="closePaymentModal()"
        (save)="onSaveCarrierPayment($event)">
      </app-payment-edit-modal>

      <!-- Delete Account Section -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-body text-center">
            <button type="button" class="btn btn-outline-danger" (click)="openDeleteAccountModal()">
              <i class="bi bi-trash me-2"></i>{{'profile.delete_account' | translate}}
            </button>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- Company Carrier (Logistics Company) Layout -->
    <ng-container *ngIf="isCarrier && isCompanyCarrier">

      <!-- Confirmation Modal -->
      <ng-container *ngIf="showConfirmModal">
        <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{confirmModalTitle}}</h5>
                <button type="button" class="btn-close" (click)="closeConfirmModal()"></button>
              </div>
              <div class="modal-body">
                {{confirmModalMessage}}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeConfirmModal()">
                  {{'common.cancel' | translate}}
                </button>
                <button type="button" class="btn btn-danger" (click)="onConfirmAction()">
                  {{'common.delete' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
      </ng-container>

      <!-- Submit for Approval Section (PENDING status) -->
      <div class="col-md-12" *ngIf="carrierDetailsFromEndpoint?.status === 'PENDING'">
        <div class="alert alert-info mb-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <i class="bi bi-info-circle-fill me-2"></i>
              <strong>{{ 'carrier_profile.submit_for_approval_title' | translate }}</strong>
            </div>
            <button type="button"
                    class="btn btn-primary"
                    [disabled]="!canCarrierSubmitForApproval"
                    (click)="submitCarrierForApproval()">
              {{ 'carrier_profile.submit_for_approval' | translate }}
            </button>
          </div>

          <!-- Missing Documents Notice -->
          <div *ngIf="isCarrierDocumentMissing" class="alert alert-warning mb-2">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ 'carrier_profile.missing_documents' | translate }}
          </div>

          <!-- Phone Verification Required Notice -->
          <div *ngIf="isCarrierPhoneVerificationRequired" class="alert alert-warning mb-2">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ 'carrier_profile.verify_phone_to_submit' | translate }}
          </div>
        </div>
      </div>

      <!-- Account Rejected Notice -->
      <div class="col-md-12" *ngIf="isCarrierRejected">
        <div class="alert alert-danger mb-4">
          <div class="d-flex align-items-start">
            <i class="bi bi-x-circle-fill me-2 fs-4"></i>
            <div class="flex-grow-1">
              <h5 class="alert-heading mb-2">{{ 'carrier_profile.account_rejected_title' | translate }}</h5>
              <p class="mb-2">{{ 'carrier_profile.account_rejected_message' | translate }}</p>
              <hr class="my-2">
              <p class="mb-0"><strong>{{ 'carrier_profile.rejection_reason' | translate }}:</strong> {{ carrierRejectionReason }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Resubmit for Approval Section (REJECTED status) -->
      <div class="col-md-12" *ngIf="carrierDetailsFromEndpoint?.status === 'REJECTED'">
        <div class="alert alert-warning mb-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <i class="bi bi-arrow-clockwise me-2"></i>
              {{ 'carrier_profile.resubmit_notice' | translate }}
            </div>
            <button type="button"
                    class="btn btn-warning"
                    [disabled]="!canCarrierSubmitForApproval"
                    (click)="submitCarrierForApproval()">
              {{ 'carrier_profile.resubmit_for_approval' | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Completed/Under Review Status Notice -->
      <div class="col-md-12" *ngIf="carrierDetailsFromEndpoint?.status === 'COMPLETED'">
        <div class="alert alert-warning mb-4">
          <i class="bi bi-info-circle-fill me-2"></i>
          {{ 'carrier_profile.pending_approval_notice' | translate }}
        </div>
      </div>

      <!-- Card 1: Company Identity -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{'carrier_profile.company_identity' | translate}}</h5>
            <button type="button" class="btn btn-sm btn-outline-primary" *ngIf="canEditCarrierInfo" (click)="openEditCarrierCompanyInfoModal()">{{'common.edit' | translate}}</button>
          </div>
          <div class="card-body">
            <p><span class="badge bg-success mb-2">{{'carrier_profile.logistics_company' | translate}}</span></p>
            <p><label>{{'carrier_profile.company_name' | translate}} : </label> {{carrierDetailsFromEndpoint?.companyName }}</p>
            <p><label>{{'carrier_profile.full_name' | translate}} : </label> {{carrierDetailsFromEndpoint?.legalRepresentative?.fullName }}</p>
            <p><label>{{'dashboard.email_address' | translate}} :</label> {{user?.email }}</p>
            <p><label>{{'login.phone_number' | translate}} :</label> {{user?.phone }}</p>
          </div>
        </div>
      </div>

      <!-- Card 2: Legal Information -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5>{{'carrier_profile.legal_info' | translate}}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <p><label>{{'carrier_profile.rccm' | translate}} :</label> {{carrierDetailsFromEndpoint?.legalInfo?.rccm || '-'}}</p>
              </div>
              <div class="col-md-4">
                <p><label>{{'carrier_profile.niu' | translate}} :</label> {{carrierDetailsFromEndpoint?.legalInfo?.niu || '-'}}</p>
              </div>
              <div class="col-md-4">
                <p><label>{{'carrier_profile.business_license' | translate}} :</label> {{carrierDetailsFromEndpoint?.legalInfo?.businessLicenseNumber || '-'}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 3: Legal Representative -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5>{{'carrier_profile.legal_representative' | translate}}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <p><label>{{'carrier_profile.full_name' | translate}} :</label> {{carrierDetailsFromEndpoint?.legalRepresentative?.fullName }}</p>
              </div>
              <div class="col-md-4">
                <p><label>{{'carrier_profile.position' | translate}} :</label> {{carrierDetailsFromEndpoint?.legalRepresentative?.position }}</p>
              </div>
              <div class="col-md-4">
                <p><label>{{'common.phone' | translate}} :</label> {{carrierDetailsFromEndpoint?.legalRepresentative?.phoneNumber }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 4: Operational Information -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5>{{'carrier_profile.operational_info' | translate}}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <p><label>{{'carrier_profile.company_email' | translate}} :</label> {{carrierDetailsFromEndpoint?.operationalInfo?.companyEmail || '-'}}</p>
                <p><label>{{'carrier_profile.company_phone' | translate}} :</label> {{carrierDetailsFromEndpoint?.operationalInfo?.companyPhoneNumber }}</p>
                <p><label>{{'common.country' | translate}} :</label> {{carrierDetailsFromEndpoint?.operationalInfo?.country }}</p>
                <p><label>{{'common.city' | translate}} :</label> {{carrierDetailsFromEndpoint?.operationalInfo?.city }}</p>
              </div>
              <div class="col-md-6">
                <p><label>{{'carrier_profile.address' | translate}} :</label> {{carrierDetailsFromEndpoint?.operationalInfo?.address || '-'}}</p>
                <p *ngIf="carrierDetailsFromEndpoint?.operationalInfo?.description">
                  <label>{{'carrier_profile.description' | translate}} :</label> {{carrierDetailsFromEndpoint?.operationalInfo?.description}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 5: Payment Information -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">{{'carrier_profile.payment_info' | translate}}</h5>
          </div>
          <div class="card-body">
            <ng-container *ngIf="carrierDetailsFromEndpoint?.paymentInfo?.paymentType === 'MOBILE_MONEY'">
              <p><label>{{'carrier_profile.payment_type' | translate}} :</label> {{'carrier_profile.mobile_money' | translate}}</p>
              <p><label>{{'carrier_profile.provider' | translate}} :</label> {{carrierDetailsFromEndpoint?.paymentInfo?.mobileMoneyProvider}}</p>
              <p class="d-flex align-items-center">
                <label class="mb-0">{{'carrier_profile.mobile_number' | translate}} :</label>
                <span class="ms-2">{{carrierDetailsFromEndpoint?.paymentInfo?.mobileMoneyNumber}}</span>
                <button type="button" *ngIf="needsCarrierPhoneVerification" class="btn btn-sm btn-warning ms-2" (click)="openCarrierVerificationModal()">
                  {{'carrier_profile.verify' | translate}}
                </button>
                <span *ngIf="!needsCarrierPhoneVerification && carrierDetailsFromEndpoint?.paymentInfo?.numberVerified" class="badge bg-success ms-2">
                  <i class="fas fa-check me-1"></i>{{'carrier_profile.verified' | translate}}
                </span>
              </p>
            </ng-container>

            <ng-container *ngIf="carrierDetailsFromEndpoint?.paymentInfo?.paymentType === 'BANK'">
              <p><label>{{'carrier_profile.payment_type' | translate}} :</label> {{'carrier_profile.bank_transfer' | translate}}</p>
              <p><label>{{'carrier_profile.bank_name' | translate}} :</label> {{carrierDetailsFromEndpoint?.paymentInfo?.bankName}}</p>
              <p><label>{{'carrier_profile.account_number' | translate}} :</label> {{carrierDetailsFromEndpoint?.paymentInfo?.accountNumber}}</p>
              <p><label>{{'carrier_profile.account_holder' | translate}} :</label> {{carrierDetailsFromEndpoint?.paymentInfo?.accountHolderName}}</p>
            </ng-container>

            <ng-container *ngIf="!carrierDetailsFromEndpoint?.paymentInfo">
              <p class="text-muted">{{'carrier_profile.no_payment_info' | translate}}</p>
            </ng-container>
            <button type="button" class="btn btn-sm btn-outline-primary mt-2" *ngIf="canEditCarrierInfo" (click)="openEditCarrierPaymentModal()">{{'common.edit' | translate}}</button>
          </div>
        </div>
      </div>

      <!-- Card 6: Documents -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h5>{{'carrier_profile.documents' | translate}}</h5>
          </div>
          <div class="card-body">
            <!-- Identity Document (IdCard or Passport) -->
            <div class="mb-4 pb-3 border-bottom">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0">{{'carrier_profile.identity_document' | translate}}</h6>
                <span *ngIf="isCompanyDocumentUploaded('IdCard') || isCompanyDocumentUploaded('Passport')" class="badge bg-success">
                  {{'carrier_profile.uploaded' | translate}}
                </span>
                <span *ngIf="!isCompanyDocumentUploaded('IdCard') && !isCompanyDocumentUploaded('Passport')" class="badge bg-warning">
                  {{'common.missing' | translate}}
                </span>
              </div>
              <ng-container *ngIf="isCompanyDocumentUploaded('IdCard') || isCompanyDocumentUploaded('Passport')">
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadCarrierDocument(getCompanyDocumentByType('IdCard')?.id || getCompanyDocumentByType('Passport')?.id)">
                    <i class="bi bi-download me-1"></i>{{'carrier_profile.download' | translate}}
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="canDeleteCarrierDocuments" (click)="deleteCarrierDocument(getCompanyDocumentByType('IdCard')?.id || getCompanyDocumentByType('Passport')?.id)">
                    <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                  </button>
                </div>
              </ng-container>
              <button *ngIf="(!isCompanyDocumentUploaded('IdCard') && !isCompanyDocumentUploaded('Passport')) && canEditCarrierInfo" 
                      type="button" class="btn btn-success btn-sm" 
                      (click)="openCompanyDocumentUploadModal('identity')">
                <i class="bi bi-upload me-1"></i>{{'carrier_profile.upload_document' | translate}}
              </button>
            </div>

            <!-- Registration Certificate -->
            <div class="mb-4 pb-3 border-bottom">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0">{{'carrier_profile.registration_document' | translate}}</h6>
                <span *ngIf="isCompanyDocumentUploaded('RegistrationCertificate')" class="badge bg-success">
                  {{'carrier_profile.uploaded' | translate}}
                </span>
                <span *ngIf="!isCompanyDocumentUploaded('RegistrationCertificate')" class="badge bg-warning">
                  {{'common.missing' | translate}}
                </span>
              </div>
              <ng-container *ngIf="isCompanyDocumentUploaded('RegistrationCertificate')">
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadCarrierDocument(getCompanyDocumentByType('RegistrationCertificate')?.id)">
                    <i class="bi bi-download me-1"></i>{{'carrier_profile.download' | translate}}
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="canDeleteCarrierDocuments" (click)="deleteCarrierDocument(getCompanyDocumentByType('RegistrationCertificate')?.id)">
                    <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                  </button>
                </div>
              </ng-container>
              <button *ngIf="!isCompanyDocumentUploaded('RegistrationCertificate') && canEditCarrierInfo" 
                      type="button" class="btn btn-success btn-sm" 
                      (click)="openCompanyDocumentUploadModal('registration')">
                <i class="bi bi-upload me-1"></i>{{'carrier_profile.upload_document' | translate}}
              </button>
            </div>

            <!-- Tax Compliance Certificate -->
            <div class="mb-4 pb-3 border-bottom">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0">{{'carrier_profile.tax_compliance_certificate' | translate}}</h6>
                <span *ngIf="isCompanyDocumentUploaded('TaxComplianceCertificate')" class="badge bg-success">
                  {{'carrier_profile.uploaded' | translate}}
                </span>
                <span *ngIf="!isCompanyDocumentUploaded('TaxComplianceCertificate')" class="badge bg-warning">
                  {{'common.missing' | translate}}
                </span>
              </div>
              <ng-container *ngIf="isCompanyDocumentUploaded('TaxComplianceCertificate')">
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadCarrierDocument(getCompanyDocumentByType('TaxComplianceCertificate')?.id)">
                    <i class="bi bi-download me-1"></i>{{'carrier_profile.download' | translate}}
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="canDeleteCarrierDocuments" (click)="deleteCarrierDocument(getCompanyDocumentByType('TaxComplianceCertificate')?.id)">
                    <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                  </button>
                </div>
              </ng-container>
              <button *ngIf="!isCompanyDocumentUploaded('TaxComplianceCertificate') && canEditCarrierInfo" 
                      type="button" class="btn btn-success btn-sm" 
                      (click)="openCompanyDocumentUploadModal('tax')">
                <i class="bi bi-upload me-1"></i>{{'carrier_profile.upload_document' | translate}}
              </button>
            </div>

            <!-- Registration of Incorporation -->
            <div class="mb-4">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0">{{'carrier_profile.registration_of_incorporation' | translate}}</h6>
                <span *ngIf="isCompanyDocumentUploaded('RegistrationOfIncorporation')" class="badge bg-success">
                  {{'carrier_profile.uploaded' | translate}}
                </span>
                <span *ngIf="!isCompanyDocumentUploaded('RegistrationOfIncorporation')" class="badge bg-warning">
                  {{'common.missing' | translate}}
                </span>
              </div>
              <ng-container *ngIf="isCompanyDocumentUploaded('RegistrationOfIncorporation')">
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadCarrierDocument(getCompanyDocumentByType('RegistrationOfIncorporation')?.id)">
                    <i class="bi bi-download me-1"></i>{{'carrier_profile.download' | translate}}
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="canDeleteCarrierDocuments" (click)="deleteCarrierDocument(getCompanyDocumentByType('RegistrationOfIncorporation')?.id)">
                    <i class="bi bi-trash me-1"></i>{{'common.delete' | translate}}
                  </button>
                </div>
              </ng-container>
              <button *ngIf="!isCompanyDocumentUploaded('RegistrationOfIncorporation') && canEditCarrierInfo" 
                      type="button" class="btn btn-success btn-sm" 
                      (click)="openCompanyDocumentUploadModal('incorporation')">
                <i class="bi bi-upload me-1"></i>{{'carrier_profile.upload_document' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Carrier Verification Modal -->
      <app-verification-modal
        [isOpen]="showVerificationModal"
        [phoneNumber]="carrierDetailsFromEndpoint?.paymentInfo?.mobileMoneyNumber"
        [resendDisabled]="resendDisabled"
        [resendCountdown]="resendCountdown"
        [errorMessage]="verificationError"
        (close)="closeVerificationModal()"
        (submit)="onVerifyCarrierCode($event)"
        (resend)="onResendCarrierCode()">
      </app-verification-modal>

      <!-- Carrier Document Upload Modal -->
      <app-document-upload-modal
        [isOpen]="showUploadModal"
        [documentType]="'identity'"
        [sellerType]="'company'"
        [resourceType]="'LogisticCompany'"
        [sellerId]="carrierDetailsFromEndpoint?.id"
        [autoReload]="true"
        (close)="closeUploadModal()"
        (uploadComplete)="onCarrierDocumentUploaded($event)">
      </app-document-upload-modal>

      <!-- Company Document Upload Modal (Inline) -->
      <ng-container *ngIf="showCompanyDocumentUploadModal">
        <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{ 'carrier_profile.upload_document' | translate }} -
                  <ng-container *ngIf="currentUploadDocType === 'identity'">{{ 'carrier_setup.identity_document' | translate }}</ng-container>
                  <ng-container *ngIf="currentUploadDocType === 'registration'">{{ 'carrier_setup.registration_document' | translate }}</ng-container>
                  <ng-container *ngIf="currentUploadDocType === 'tax'">{{ 'carrier_setup.tax_compliance_certificate' | translate }}</ng-container>
                  <ng-container *ngIf="currentUploadDocType === 'incorporation'">{{ 'carrier_setup.registration_of_incorporation' | translate }}</ng-container>
                </h5>
                <button type="button" class="btn-close" (click)="closeCompanyDocumentUploadModal()"></button>
              </div>
              <div class="modal-body">
                <!-- Tax Compliance Delivery Date -->
                <div *ngIf="currentUploadDocType === 'tax'" class="mb-3">
                  <label for="companyTaxDeliveryDate" class="form-label">
                    {{ 'carrier_setup.delivery_date' | translate }} *
                  </label>
                  <input
                    type="date"
                    id="companyTaxDeliveryDate"
                    class="form-control"
                    [(ngModel)]="companyTaxDeliveryDate"
                    [ngModelOptions]="{standalone: true}">
                  <small class="form-text text-muted">
                    {{ 'carrier_setup.delivery_date_help' | translate }}
                  </small>
                </div>

                <!-- File Input -->
                <div class="mb-3">
                  <label for="companyDocFile" class="form-label">
                    {{ 'carrier_setup.upload_file' | translate }}
                  </label>
                  <input
                    type="file"
                    id="companyDocFile"
                    class="form-control"
                    accept=".pdf,.jpg,.jpeg,.png"
                    (change)="onCompanyDocumentFileSelected($event)">
                  <small class="form-text text-muted">
                    {{ 'carrier_setup.file_requirements' | translate }}
                  </small>
                </div>

                <!-- File Preview -->
                <div *ngIf="companyDocumentFile" class="d-flex justify-content-between align-items-center p-2 bg-light rounded mb-3">
                  <span>{{ companyDocumentFile.name }}</span>
                  <button type="button" class="btn btn-sm btn-outline-danger" (click)="companyDocumentFile = null">
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeCompanyDocumentUploadModal()">
                  {{ 'common.cancel' | translate }}
                </button>
                <button type="button"
                        class="btn btn-primary"
                        [disabled]="!companyDocumentFile || companyDocumentUploading || (currentUploadDocType === 'tax' && !companyTaxDeliveryDate)"
                        (click)="uploadCompanyDocumentFromModal()">
                  <span *ngIf="companyDocumentUploading" class="spinner-border spinner-border-sm me-2"></span>
                  {{ 'carrier_setup.upload' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
      </ng-container>

      <!-- Carrier Payment Edit Modal -->
      <app-payment-edit-modal
        [isOpen]="showPaymentModal"
        [existingPaymentInfo]="existingPaymentInfo"
        (close)="closePaymentModal()"
        (save)="onSaveCarrierPayment($event)">
      </app-payment-edit-modal>

      <!-- Carrier Company Info Edit Modal -->
      <app-company-info-edit-modal
        [isOpen]="showCompanyInfoModal"
        [existingCompanyInfo]="existingCompanyInfo"
        (close)="closeCompanyInfoModal()"
        (save)="onSaveCarrierCompanyInfo($event)">
      </app-company-info-edit-modal>

      <!-- Delete Account Section -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-body text-center">
            <button type="button" class="btn btn-outline-danger" (click)="openDeleteAccountModal()">
              <i class="bi bi-trash me-2"></i>{{'profile.delete_account' | translate}}
            </button>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- Buyer Layout (Default) -->
    <ng-container *ngIf="isBuyer">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5>{{'dashboard.contact_infos' | translate}}</h5>
          </div>
          <div class="card-body">
            <p><label>{{'dashboard.full_name' | translate}} : </label> {{user?.firstName + ' ' + user?.lastName }}</p>
            <p><label>{{'dashboard.email_address' | translate}} :</label> {{user?.email }}</p>
            <p><label>{{'login.phone_number' | translate}} :</label> {{user?.phone }}</p>
            <p><label>{{'common.country' | translate}}: </label> {{ user?.country?.name || '-' }}</p>
            <p><label>{{'common.city' | translate}} :</label> {{user?.town }}</p>
            <p><a class="btn btn-primary" [routerLink]="['/user/' + (user?.id ?? '') + '/edit']">{{'common.edit' | translate}}</a></p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" id="shipping-box">
            <h5>{{'dashboard.default_shipping_address' | translate}}</h5>
          </div>
          <div class="card-body">
            <div *ngIf="defaultShippingAddress">
              <p><label>{{'common.name' | translate}} :</label> {{ defaultShippingAddress.name }}</p>
              <p><label>{{'user_profile.region' | translate}} :</label> {{ defaultShippingAddress.region }}</p>
              <p><label>{{'common.city' | translate}} :</label> {{ defaultShippingAddress.town }}</p>
              <p><label>{{'user_profile.address_1' | translate}} :</label> {{ defaultShippingAddress.addressLine1 }}</p>
              <p><label>{{'user_profile.address_2' | translate}} :</label> {{ defaultShippingAddress.addressLine2 }}</p>
            </div>
            <p><a class="btn btn-primary" [routerLink]="['/user/shipping-addresses']">{{'sidebar.my_addresses' | translate}}</a></p>
          </div>
        </div>
      </div>

      <!-- Delete Account Section -->
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-body text-center">
            <button type="button" class="btn btn-outline-danger" (click)="openDeleteAccountModal()">
              <i class="bi bi-trash me-2"></i>{{'profile.delete_account' | translate}}
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Delete Account Confirmation Modal -->
    <ng-container *ngIf="showDeleteAccountModal">
      <div class="modal show" style="display: block; z-index: 10000;" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>{{'profile.delete_account' | translate}}
              </h5>
              <button type="button" class="btn-close" (click)="closeDeleteAccountModal()"></button>
            </div>
            <div class="modal-body">
              <p class="fw-bold">{{'profile.delete_account_warning' | translate}}</p>
              <p>{{'profile.delete_account_message' | translate}}</p>
              <div class="mb-3">
                <label for="deleteConfirmation" class="form-label fw-bold">
                  {{'profile.type_to_confirm_prefix' | translate}} <strong class="text-danger">DELETE</strong> {{'profile.type_to_confirm_suffix' | translate}}
                </label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="deleteConfirmation" 
                  [(ngModel)]="deleteAccountConfirmationText"
                  placeholder="DELETE"
                  autocomplete="off">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" (click)="closeDeleteAccountModal()">
                {{'common.cancel' | translate}}
              </button>
              <button 
                type="button" 
                class="btn btn-danger" 
                [disabled]="!isDeleteConfirmationValid || deleteAccountLoading"
                (click)="confirmDeleteAccount()">
                <span *ngIf="deleteAccountLoading" class="spinner-border spinner-border-sm me-2"></span>
                <i *ngIf="!deleteAccountLoading" class="bi bi-trash me-2"></i>
                {{'profile.permanently_delete' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show" style="z-index: 9999;"></div>
    </ng-container>

  </ng-template>
</div>